import { render, staticRenderFns } from "./EntryTitle.vue?vue&type=template&id=5dbfe889&scoped=true"
import script from "./EntryTitle.vue?vue&type=script&lang=js"
export * from "./EntryTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbfe889",
  null
  
)

export default component.exports